<label
  [class.has-error]="required() && !formControlRef().value"
  [class.disabled]="disabled()"
  [class.show-full-text]="showFullText()"
  [ngClass]="color()">
  <input
    type="checkbox"
    class="accredible-checkbox"
    [attr.data-cy]="dataCy()"
    [formControl]="formControlRef()"
    [attr.aria-label]="label()"
    [attr.aria-checked]="formControlRef().value"
    [attr.aria-describedby]="hint() || ''"
    [attr.aria-disabled]="disabled()"
    [attr.tabindex]="tabIndex()"
    (change)="onChange($event)" />

  <span class="input-box">
    <accredible-icon class="font-xs-regular" [icon]="'check'" />
  </span>

  <span class="input-text font-normal-regular" [innerHTML]="label()"></span>
</label>

@if (hint()) {
  <div class="hint font-s-regular">
    {{ hint() }}
  </div>
}
